import { connect } from 'react-redux'
import unitConverterForm from '../ui/forms/unitConverterForm'
import { setUnitConverterValues } from '../../store/actions/unitConverterActions'

const mapStateToProps = state => ({
    unitConverterValues: state.formulas.unitConverter
})

const mapDispatchToProps = dispatch => {
    return {
        formToState: (val) => {
            dispatch(
                setUnitConverterValues(val)
            )
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(unitConverterForm)